var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"whatsapp-preview-container",domProps:{"innerHTML":_vm._s(_vm.parsedMessage)}}),_c('br'),_c('span',{staticClass:"whatsapp-preview-container"},[_vm._v("Para deixar de receber ofertas, envie #sair.")])])}
var staticRenderFns = []

export { render, staticRenderFns }